import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DataTable from 'base/components/table/DataTable/index';
import MainTitle from 'base/components/MainTitle/index';
import Header from 'base/components/Header/index';
import { AddIcon, EmailIcon } from 'base/components/Icon/index';
import { getAllMailingLists } from 'documents/store/mailinglists/selectors';
import { fetchAllMailingLists, setActiveMailingListId } from 'documents/store/mailinglists/actions';
import theme from 'theme/theme';
import Button from 'base/components/Button/index';
import ButtonGroup from 'base/components/ButtonGroup/index';
import { openModal } from 'modal/store/actions';
import { getEditColumn, getDeleteColumn } from 'base/components/table/RowActionButton';
import withGlobalFilter from 'base/components/table/withGlobalFilter';
import { LargeLabelCell } from 'base/components/table';
import { getUsersById } from 'auth/store/users/selectors';

const FilteredTable = withGlobalFilter(DataTable);

class ManageMailingLists extends React.Component {
  componentDidMount() {
    const { fetchAll } = this.props;
    fetchAll();
  }

  handleEdit = (data) => {
    const { setActiveMailingListId, openModal } = this.props;
    setActiveMailingListId(data.id);
    openModal('MAILING_LIST_EDIT');
  };

  handleDelete = (data) => {
    const { setActiveMailingListId, openModal } = this.props;
    setActiveMailingListId(data.id);
    openModal('MAILING_LIST_DELETE');
  };

  render() {
    const { mailingLists, openModal, usersById } = this.props; // eslint-disable-line

    const columns = [
      {
        Header: 'Name',
        accessor: 'name',
        Cell: LargeLabelCell('name'),
        showOnMobile: true,
      },
      // {
      //   id: 'owner',
      //   Header: 'Members',
      //   accessor: (row) => usersById[row.members] && usersById[row.members].fullName,
      //   Cell: SmallLabelCell('owner'),
      //   showOnMobile: true,
      //   width: 180,
      // },
      getEditColumn(this.handleEdit),
      getDeleteColumn(this.handleDelete),
    ];

    return (
      <>
        <Header>
          <MainTitle>
            <EmailIcon />
            {' '}
            Manage mailing lists
          </MainTitle>
          <ButtonGroup pullRight>
            <Button onClick={() => openModal('MAILING_LIST_CREATE')}>
              <AddIcon color={theme.colors.medium} />
              {' '}
              New mailing list
            </Button>
          </ButtonGroup>
        </Header>
        <FilteredTable
          data={mailingLists}
          columns={columns}
          defaultSorted={[{
            id: 'name',
            desc: false,
          }]}
          filterKeys={['name']}
          filterLabel="Filter by name..."
        />
      </>
    );
  }
}
ManageMailingLists.propTypes = {
  mailingLists: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchAll: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  setActiveMailingListId: PropTypes.func.isRequired,
  usersById: PropTypes.objectOf(PropTypes.any).isRequired,
};


const mapStateToProps = (state) => ({
  mailingLists: getAllMailingLists(state),
  usersById: getUsersById(state),
});

const mapDispatchToProps = {
  fetchAll: fetchAllMailingLists,
  openModal,
  setActiveMailingListId,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageMailingLists);
